<template>
  <div class="tarjetas-plasticos-list">
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Tarjetas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="tarjetasPlasticos" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(credito)="data">
              {{ (data.item.credito) ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(fechaVigenciaHasta)="data">
              {{ data.item.fechaVigenciaHasta | periodo }}
            </template>
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos de la Tarjeta</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Plástico</b-dropdown-item>
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetasPlasticos/getField',
  mutationType: 'tarjetasPlasticos/updateField',
});

export default {
  name: 'TarjetasList',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'banco',
          sortable: true
        },
        {
          key: 'tarjetaMarca',
          label: 'Marca',
          sortable: true
        },
        {
          key: 'numero',
          sortable: true
        },
        {
          key: 'titular',
          sortable: true
        },
        { 
          key: 'credito',
          class: 'text-center', 
        },
        { 
          key: 'fechaVigenciaHasta',
          label: 'Vigencia Hasta'
        },
        { 
          key: 'inactivo',
          class: 'text-center', 
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'tarjetaId',
      'tarjetasPlasticos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    let tarjetaId = 0;
    if (this.$route.params){
      if (this.$route.params.tarjetaId){
        tarjetaId = this.$route.params.tarjetaId;
      }
    }

    this.$store.dispatch('tarjetasPlasticos/inicializar', tarjetaId)
      .then(() => this.getItems())
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('tarjetasPlasticos/getTarjetasPlasticos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar(item) {
      this.$router.push({ name: 'TarjetaPlasticoData', 
                          params: { 
                            tarjetaPlasticoId: this.tarjetaPlasticoId,
                            id: item.id 
                        }});
    },
    editar(item) {
      this.$router.push({ name: 'TarjetaPlasticoEdit', 
                          params: { 
                            tarjetaPlasticoId: this.tarjetaPlasticoId,
                            id: item.id 
                        }});
    },
    agregar() {
      this.$router.push({ name: 'TarjetaPlasticoAdd',
                          params: { tarjetaPlasticoId: this.tarjetaPlasticoId }});
    },
    goBack() {
      this.$router.push({ name: 'Tarjetas' });
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .tarjetas-plasticos-list .registro table td[aria-colindex="1"] {
    width: 15%;
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="3"] {
    width: 15%;
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="4"] {
    width: calc(25% - 30px);
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="5"] {
    width: 10%;
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="6"] {
    width: 15%;
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="7"] {
    width: 10%;
  }
  .tarjetas-plasticos-list .registro table td[aria-colindex="8"] {
    width: 30px;
  }

</style>
